import { useQuery } from '@tanstack/react-query';

import { KEYS } from '~/shared/api/query-keys';
import { baseAPI } from '~shared/api/base-api';

export interface WaitListedStudent {
  waitlistId: string;
  studentId: string;
  parentId: string;
  parentName: string;
  position: number;
  studentName: string;
  gender: string;
  dob: string; // ISO date string
  age: number;
  parentEmail: string;
  parentPhone: string;
  joinedAt: string; // ISO date string
  priority: 'normal' | 'urgent' | 'high';
}

export interface WaitListSummaryResponse {
  enrollmentId: string;
  enrollmentTitle: string;
  maxSize: number;
  maxWait: number;
  currentEnrolled: number;
  availableSeats: number;
  waitlistCount: number;
  waitlistPositions: Array<WaitListedStudent>;
}

interface GetWaitListSummaryParams {
  classId: string;
}

export const getWaitListSummaryAPI = async ({
  classId,
}: GetWaitListSummaryParams) => {
  const response = await baseAPI.get<WaitListSummaryResponse>(
    `/waitlist/enrollment/${classId}/summary`,
  );
  return response.data;
};

export const useGetWaitListSummary = ({
  classId,
}: GetWaitListSummaryParams) => {
  return useQuery({
    queryKey: [KEYS.WAIT_LIST_SUMMARY, classId],
    queryFn: () => getWaitListSummaryAPI({ classId }),
  });
};
